// Estados honestos de carga: una LECTURA que falla LANZA LoadError en vez de
// devolver [] / null / valores por defecto. Así la pantalla distingue
// «no hay datos» (vacío) de «no pudimos traerlos» (error con Reintentar) y
// nunca afirma algo falso («MFA no activado», «¡todo listo!», «turno
// inválido») por un fallo de red.

export class LoadError extends Error {
  readonly scope: string;
  constructor(scope: string, detail?: string) {
    super(`${scope}: ${detail ?? 'load failed'}`);
    this.name = 'LoadError';
    this.scope = scope;
  }
}

/** Registra y lanza. Uso: `if (error) loadFailed('clients.list', error)`. */
export function loadFailed(scope: string, err?: { message?: string } | string | null): never {
  const detail = typeof err === 'string' ? err : err?.message;
  console.warn(`[VaulTex] ${scope}:`, detail ?? 'load failed');
  throw new LoadError(scope, detail);
}

/** Para vistas AGREGADAS que muestran lo que haya (avisos, cronología,
 *  copiloto): un origen caído no tumba la vista entera. Las pantallas que
 *  muestran ESE dato como principal no usan esto: muestran el error. */
export async function tolerate<T>(p: Promise<T>, fallback: T): Promise<T> {
  try {
    return await p;
  } catch {
    return fallback;
  }
}

/** Para el `catch` de una lectura envuelta en try: relanza como LoadError
 *  (sin duplicar el registro si ya lo era). */
export function rethrowLoad(scope: string, e: unknown): never {
  if (e instanceof LoadError) throw e;
  return loadFailed(scope, e instanceof Error ? e.message : String(e));
}
